export type APIVersion = {
  m?: string;
  w?: string;
  l?: string;
  i?: string;
  a?: string;
};

export type APIKeys =
  | 'accessibility.getChatDisplaySize'
  | 'appBridge.config'
  | 'appBridge.reset'
  | 'appBridge.getService'
  | 'appBridge.pub'
  | 'apps.callZoomApi'
  | 'apps.on'
  | 'apps.off'
  | 'apps.addEventListener'
  | 'apps.removeEventListener'
  | 'apps.config'
  | 'apps.zmGetUserInfo'
  | 'apps.zmGetClientInfo'
  | 'apps.zmGetAICOption'
  | 'apps.zmGetLanguage'
  | 'apps.zmOpenSettings'
  | 'apps.zmNotifyStaticResourceUpdate'
  | 'apps.zmGetAuthToken'
  | 'apps.zmGetChatInfo'
  | 'apps.composeCard'
  | 'apps.closeModal'
  | 'apps.getUserContext'
  | 'apps.zmRefreshApp'
  | 'apps.zmOpenUrl'
  | 'apps.zmGetMeetingQueryStatus'
  | 'apps.zmSetMeetingQueryPrivilegeSetting'
  | 'apps.zmGetMeetingQueryPrivilegeSetting'
  | 'apps.zmGetUserInfoMeetingToken'
  | 'apps.zmGetMeetingSummaryStatus'
  | 'apps.zmGetPAAPLogServiceInfo'
  | 'apps.zmGetMyMeetingSpeakingLanguage'
  | 'apps.zmMyMeetingQueryPrivileges'
  | 'apps.zmCommonAicAction'
  | 'apps.zmGetMeetingUUID'
  | 'apps.zmSetCookie'
  | 'apps.zmDeleteCookie'
  | 'apps.zmGetStaticResourceConfiguration'
  | 'apps.zmCommonAicActionForPhone'
  | 'apps.onZmCommonAicActionForPhoneEvent'
  | 'auth.getNak'
  | 'auth.getZak'
  | 'auth.onZakUpdated'
  | 'auth.offZakUpdated'
  | 'auth.getPak'
  | 'auth.refreshPak'
  | 'auth.onPakUpdated'
  | 'auth.offPakUpdated'
  | 'clipboard.read'
  | 'clipboard.write'
  | 'common.openLinkInBrowser'
  | 'common.log'
  | 'common.screenshot'
  | 'common.appReady'
  | 'common.isDogfoodBuild'
  | 'download.startDownload'
  | 'download.pauseDownload'
  | 'download.resumeDownload'
  | 'download.cancelDownload'
  | 'download.getDownloadInfo'
  | 'download.onDownloadProgress'
  | 'download.offDownloadProgress'
  | 'filesystem.openSysDlgSelectPath'
  | 'filesystem.openSysDlgSelectDirectory'
  | 'filesystem.saveAsFile'
  | 'filesystem.openFilePicker'
  | 'filesystem.getFileAbility'
  | 'filesystem.getFileInfo'
  | 'filesystem.read'
  | 'filesystem.openSysFileExplorer'
  | 'filesystem.checkPathExists'
  | 'history.push'
  | 'history.deleteItem'
  | 'history.confirmPop'
  | 'history.registerHistoryPopListener'
  | 'history.unregisterHistoryPopListener'
  | 'http.request'
  | 'language.getClientLanguage'
  | 'mobile.getSafeArea'
  | 'mobile.onSafeAreaChange'
  | 'mobile.offSafeAreaChange'
  | 'mobile.getKeyboardRect'
  | 'mobile.onKeyboardRectChange'
  | 'mobile.offKeyboardRectChange'
  | 'mobile.setDetailNavigationBarConfig'
  | 'mobile.removeDetailNavigationBarListeners'
  | 'mobile.registerEvent'
  | 'mobile.unregisterEvent'
  | 'mobile.removeEventAllListeners'
  | 'mobile.setFloatingActionButtonConfig'
  | 'mobile.setNavigationBarConfig'
  | 'mobile.cancelSearch'
  | 'mobile.activeSearch'
  | 'mobile.setSubNavigationConfig'
  | 'mobile.updateSubNavigationItem'
  | 'mobile.setSelectedSubNavigationItem'
  | 'network.onNetworkStateChanged'
  | 'network.offNetworkStateChanged'
  | 'permissions.queryPermission'
  | 'permissions.resetPermission'
  | 'platform.getSystemParam'
  | 'platform.onTimeZoneChange'
  | 'platform.offTimeZoneChange'
  | 'platform.onTimeFormatChange'
  | 'platform.offTimeFormatChange'
  | 'platform.getClientSetting'
  | 'platform.onClientSettingChanged'
  | 'platform.offClientSettingChanged'
  | 'serviceHub.addEventListener'
  | 'serviceHub.executeAction'
  | 'serviceHub.queryAllSkills'
  | 'serviceHub.getAllServices'
  | 'serviceHub.zmNotifyListeners'
  | 'serviceHub.getService'
  | 'serviceHub.getAvailableServices'
  | 'serviceHub.callAction'
  | 'serviceHub.registerJSService'
  | 'serviceHub.unregisterJSService'
  | 'serviceHub.getRegisteredJSServices'
  | 'serviceHub.onServiceChanged'
  | 'serviceHub.offServiceChanged'
  | 'serviceHub.destroy'
  | 'theme.getClientTheme'
  | 'theme.getClientSkin'
  | 'theme.getEmojiReactionSkin'
  | 'theme.registerThemeChangeListener'
  | 'theme.unregisterThemeChangeListener'
  | 'theme.onClientSkinChange'
  | 'theme.offClientSkinChange'
  | 'theme.onWebviewThemeChange'
  | 'theme.offWebviewThemeChange'
  | 'webview.enableHeartbeat'
  | 'webview.disableHeartbeat'
  | 'webview.getHeartbeatStatus'
  | 'webview.closeWebview'
  | 'webview.getWebviewId'
  | 'webview.onVisibilityChange'
  | 'webview.offVisibilityChange'
  | 'webview.send'
  | 'webview.onReceiveMessage'
  | 'webview.offReceiveMessage'
  | 'webview.replyNotification'
  | 'webview.getPendingRequests'
  | 'webview.onWebviewWillRecycle'
  | 'webview.offWebviewWillRecycle'
  | 'webview.onWebviewLostFocus'
  | 'webview.offWebviewLostFocus'
  | 'webview.saveWebContent'
  | 'webview.restoreWebContent'
  | 'webview.resize'
  | 'webview.getRect'
  | 'webview.onPageEnterForeground'
  | 'webview.offPageEnterForeground'
  | 'webview.onPageEnterBackground'
  | 'webview.offPageEnterBackground'
  | 'webview.getPerformanceMetrics'
  | 'webview.recreate'
  | 'webview.onWebviewZoomFactorChanged'
  | 'webview.offWebviewZoomFactorChanged'
  | 'webview.setZoomFactor'
  | 'webview.getZoomFactor'
  | 'webview.readyForPushNotification'
  | 'webview.onPushNotification'
  | 'webview.offPushNotification'
  | 'webview.addShortcutListener'
  | 'webview.removeShortcutListener';
export type APIVersionMap = Record<APIKeys, APIVersion>;

export const apiVersionMap: APIVersionMap = {
  'accessibility.getChatDisplaySize': {
    m: '6.6.0',
    w: '6.6.0',
  },
  'appBridge.config': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'appBridge.reset': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'appBridge.getService': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'appBridge.pub': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.callZoomApi': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.on': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.off': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.addEventListener': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.removeEventListener': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.config': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmGetUserInfo': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmGetClientInfo': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmGetAICOption': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmGetLanguage': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmOpenSettings': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmNotifyStaticResourceUpdate': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmGetAuthToken': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmGetChatInfo': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.composeCard': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.closeModal': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.getUserContext': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmRefreshApp': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmOpenUrl': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmGetMeetingQueryStatus': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmSetMeetingQueryPrivilegeSetting': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmGetMeetingQueryPrivilegeSetting': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmGetUserInfoMeetingToken': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmGetMeetingSummaryStatus': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmGetPAAPLogServiceInfo': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmGetMyMeetingSpeakingLanguage': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmMyMeetingQueryPrivileges': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmCommonAicAction': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmGetMeetingUUID': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmSetCookie': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmDeleteCookie': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmGetStaticResourceConfiguration': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.zmCommonAicActionForPhone': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'apps.onZmCommonAicActionForPhoneEvent': {
    m: '5.11.0',
    w: '5.11.0',
    l: '5.11.0',
    i: '5.11.0',
    a: '5.11.0',
  },
  'auth.getNak': {
    m: '6.1.10',
    w: '6.1.10',
    l: '6.1.10',
    i: '6.1.10',
    a: '6.1.10',
  },
  'auth.getZak': {
    m: '6.2.5',
    w: '6.2.5',
    l: '6.2.5',
    i: '6.2.5',
    a: '6.2.5',
  },
  'auth.onZakUpdated': {
    m: '6.5.0',
    w: '6.5.0',
    l: '6.5.0',
    i: '6.5.0',
    a: '6.5.0',
  },
  'auth.offZakUpdated': {
    m: '6.5.0',
    w: '6.5.0',
    l: '6.5.0',
    i: '6.5.0',
    a: '6.5.0',
  },
  'auth.getPak': {
    m: '6.5.0',
    w: '6.5.0',
    l: '6.5.0',
    i: '6.5.0',
    a: '6.5.0',
  },
  'auth.refreshPak': {
    m: '6.5.0',
    w: '6.5.0',
    l: '6.5.0',
    i: '6.5.0',
    a: '6.5.0',
  },
  'auth.onPakUpdated': {
    m: '6.5.0',
    w: '6.5.0',
    l: '6.5.0',
    i: '6.5.0',
    a: '6.5.0',
  },
  'auth.offPakUpdated': {
    m: '6.5.0',
    w: '6.5.0',
    l: '6.5.0',
    i: '6.5.0',
    a: '6.5.0',
  },
  'clipboard.read': {
    m: '6.5.0',
    w: '6.1.0',
    l: '6.1.0',
    i: '6.6.0',
    a: '6.1.0',
  },
  'clipboard.write': {
    m: '6.5.0',
    w: '6.5.5',
    l: '6.5.5',
    i: '6.4.5',
    a: '6.1.0',
  },
  'common.openLinkInBrowser': {
    m: '5.17.0',
    w: '5.17.0',
    l: '5.17.0',
    i: '5.17.0',
    a: '5.17.0',
  },
  'common.log': {
    m: '6.4.0',
    w: '6.4.0',
    l: '6.4.0',
    i: '6.4.0',
    a: '6.4.0',
  },
  'common.screenshot': {
    m: '6.2.0',
    w: '6.2.0',
    l: '6.2.0',
  },
  'common.appReady': {
    i: '6.3.10',
    a: '6.3.10',
  },
  'common.isDogfoodBuild': {
    m: '6.4.5',
    w: '6.4.5',
    l: '6.4.5',
    i: '6.4.5',
    a: '6.4.5',
  },
  'download.startDownload': {
    m: '6.0.5',
    w: '6.0.5',
    l: '6.0.5',
    i: '6.3.0',
    a: '6.3.0',
  },
  'download.pauseDownload': {
    m: '6.0.5',
    w: '6.0.5',
    l: '6.0.5',
    i: '6.3.0',
    a: '6.3.0',
  },
  'download.resumeDownload': {
    m: '6.0.5',
    w: '6.0.5',
    l: '6.0.5',
    i: '6.3.0',
    a: '6.3.0',
  },
  'download.cancelDownload': {
    m: '6.0.5',
    w: '6.0.5',
    l: '6.0.5',
    i: '6.3.0',
    a: '6.3.0',
  },
  'download.getDownloadInfo': {
    m: '6.0.5',
    w: '6.0.5',
    l: '6.0.5',
    i: '6.3.0',
    a: '6.3.0',
  },
  'download.onDownloadProgress': {
    m: '6.0.5',
    w: '6.0.5',
    l: '6.0.5',
    i: '6.3.0',
    a: '6.3.0',
  },
  'download.offDownloadProgress': {
    m: '6.0.5',
    w: '6.0.5',
    l: '6.0.5',
    i: '6.3.0',
    a: '6.3.0',
  },
  'filesystem.openSysDlgSelectPath': {
    m: '5.17.0',
    w: '5.17.0',
    l: '5.17.0',
  },
  'filesystem.openSysDlgSelectDirectory': {
    m: '6.4.5',
    w: '6.4.5',
    l: '6.5.0',
  },
  'filesystem.saveAsFile': {
    m: '6.2.10',
    w: '6.2.10',
    l: '6.2.10',
  },
  'filesystem.openFilePicker': {
    i: '6.4.0',
    a: '6.4.0',
  },
  'filesystem.getFileAbility': {
    m: '6.4.0',
    w: '6.4.0',
    l: '6.4.0',
    i: '6.4.0',
    a: '6.4.0',
  },
  'filesystem.getFileInfo': {
    m: '6.4.0',
    w: '6.4.0',
    l: '6.4.0',
  },
  'filesystem.read': {
    m: '6.4.0',
    w: '6.4.0',
    l: '6.4.0',
    i: '6.4.0',
    a: '6.4.0',
  },
  'filesystem.openSysFileExplorer': {
    m: '6.5.0',
    w: '6.5.0',
    l: '6.5.0',
  },
  'filesystem.checkPathExists': {
    m: '6.6.0',
    w: '6.6.0',
    l: '6.6.0',
    i: '6.6.0',
    a: '6.6.0',
  },
  'history.push': {
    m: '6.2.0',
    w: '6.2.0',
    l: '6.2.0',
  },
  'history.deleteItem': {
    m: '6.5.0',
    w: '6.5.0',
    l: '6.5.0',
  },
  'history.confirmPop': {
    m: '6.2.0',
    w: '6.2.0',
    l: '6.2.0',
  },
  'history.registerHistoryPopListener': {
    m: '6.2.0',
    w: '6.2.0',
    l: '6.2.0',
  },
  'history.unregisterHistoryPopListener': {
    m: '6.2.0',
    w: '6.2.0',
    l: '6.2.0',
  },
  'http.request': {
    m: '6.2.5',
    w: '6.2.5',
    l: '6.2.5',
    i: '6.2.5',
    a: '6.2.5',
  },
  'language.getClientLanguage': {
    m: '5.17.0',
    w: '5.17.0',
    l: '5.17.0',
    i: '5.17.0',
    a: '5.17.0',
  },
  'mobile.getSafeArea': {
    i: '6.5.0',
  },
  'mobile.onSafeAreaChange': {
    i: '6.5.0',
  },
  'mobile.offSafeAreaChange': {
    i: '6.5.0',
  },
  'mobile.getKeyboardRect': {
    i: '6.6.0',
    a: '6.6.0',
  },
  'mobile.onKeyboardRectChange': {
    i: '6.6.0',
    a: '6.6.0',
  },
  'mobile.offKeyboardRectChange': {
    i: '6.6.0',
    a: '6.6.0',
  },
  'mobile.setDetailNavigationBarConfig': {
    i: '6.5.0',
    a: '6.5.0',
  },
  'mobile.removeDetailNavigationBarListeners': {
    i: '6.5.0',
    a: '6.5.0',
  },
  'mobile.registerEvent': {
    i: '6.5.0',
    a: '6.5.0',
  },
  'mobile.unregisterEvent': {
    i: '6.5.0',
    a: '6.5.0',
  },
  'mobile.removeEventAllListeners': {
    i: '6.5.0',
    a: '6.5.0',
  },
  'mobile.setFloatingActionButtonConfig': {
    i: '6.5.0',
    a: '6.5.0',
  },
  'mobile.setNavigationBarConfig': {
    i: '6.5.0',
    a: '6.5.0',
  },
  'mobile.cancelSearch': {
    i: '6.5.0',
    a: '6.5.0',
  },
  'mobile.activeSearch': {
    i: '6.5.0',
    a: '6.5.0',
  },
  'mobile.setSubNavigationConfig': {
    i: '6.5.0',
    a: '6.5.0',
  },
  'mobile.updateSubNavigationItem': {
    i: '6.5.0',
    a: '6.5.0',
  },
  'mobile.setSelectedSubNavigationItem': {
    i: '6.5.0',
    a: '6.5.0',
  },
  'network.onNetworkStateChanged': {
    m: '6.0.5',
    w: '6.0.5',
    l: '6.0.5',
  },
  'network.offNetworkStateChanged': {
    m: '6.0.5',
    w: '6.0.5',
    l: '6.0.5',
  },
  'permissions.queryPermission': {
    m: '6.4.0',
    w: '6.4.0',
    l: '6.4.0',
    i: '6.4.0',
    a: '6.4.0',
  },
  'permissions.resetPermission': {
    m: '6.4.0',
    w: '6.4.0',
    l: '6.4.0',
    i: '6.4.0',
    a: '6.4.0',
  },
  'platform.getSystemParam': {
    m: '5.17.0',
    w: '5.17.0',
    l: '5.17.0',
    i: '5.17.0',
    a: '5.17.0',
  },
  'platform.onTimeZoneChange': {
    m: '6.1.15',
    w: '6.1.15',
    i: '6.1.15',
    a: '6.1.15',
  },
  'platform.offTimeZoneChange': {
    m: '6.1.15',
    w: '6.1.15',
    i: '6.1.15',
    a: '6.1.15',
  },
  'platform.onTimeFormatChange': {
    m: '6.2.0',
    w: '6.2.0',
    i: '6.2.0',
    a: '6.2.0',
  },
  'platform.offTimeFormatChange': {
    m: '6.2.0',
    w: '6.2.0',
    i: '6.2.0',
    a: '6.2.0',
  },
  'platform.getClientSetting': {
    m: '6.4.0',
    w: '6.4.0',
    l: '6.4.0',
    i: '6.4.0',
    a: '6.4.0',
  },
  'platform.onClientSettingChanged': {
    m: '6.6.0',
    w: '6.6.0',
    l: '6.6.0',
  },
  'platform.offClientSettingChanged': {
    m: '6.6.0',
    w: '6.6.0',
    l: '6.6.0',
  },
  'serviceHub.addEventListener': {
    m: '6.3.0',
    w: '6.3.0',
    l: '6.3.0',
    i: '6.3.0',
    a: '6.3.0',
  },
  'serviceHub.executeAction': {
    m: '6.3.0',
    w: '6.3.0',
    l: '6.3.0',
    i: '6.3.0',
    a: '6.3.0',
  },
  'serviceHub.queryAllSkills': {
    m: '6.3.0',
    w: '6.3.0',
    l: '6.3.0',
    i: '6.3.0',
    a: '6.3.0',
  },
  'serviceHub.getAllServices': {
    m: '6.3.0',
    w: '6.3.0',
    l: '6.3.0',
    i: '6.3.0',
    a: '6.3.0',
  },
  'serviceHub.zmNotifyListeners': {
    m: '6.5.0',
    w: '6.5.0',
    l: '6.5.0',
    i: '6.5.0',
    a: '6.5.0',
  },
  'serviceHub.getService': {
    m: '6.4.0',
    w: '6.4.0',
    l: '6.4.0',
    i: '6.4.0',
    a: '6.4.0',
  },
  'serviceHub.getAvailableServices': {
    m: '6.4.0',
    w: '6.4.0',
    l: '6.4.0',
    i: '6.4.0',
    a: '6.4.0',
  },
  'serviceHub.callAction': {
    m: '6.3.0',
    w: '6.3.0',
    l: '6.3.0',
    i: '6.3.0',
    a: '6.3.0',
  },
  'serviceHub.registerJSService': {
    m: '6.5.0',
    w: '6.5.0',
    l: '6.5.0',
    i: '6.5.0',
    a: '6.5.0',
  },
  'serviceHub.unregisterJSService': {
    m: '6.5.0',
    w: '6.5.0',
    l: '6.5.0',
    i: '6.5.0',
    a: '6.5.0',
  },
  'serviceHub.getRegisteredJSServices': {
    m: '6.5.0',
    w: '6.5.0',
    l: '6.5.0',
    i: '6.5.0',
    a: '6.5.0',
  },
  'serviceHub.onServiceChanged': {
    m: '6.4.0',
    w: '6.4.0',
    l: '6.4.0',
    i: '6.4.0',
    a: '6.4.0',
  },
  'serviceHub.offServiceChanged': {
    m: '6.4.0',
    w: '6.4.0',
    l: '6.4.0',
    i: '6.4.0',
    a: '6.4.0',
  },
  'serviceHub.destroy': {
    m: '6.3.0',
    w: '6.3.0',
    l: '6.3.0',
    i: '6.3.0',
    a: '6.3.0',
  },
  'theme.getClientTheme': {
    m: '5.17.0',
    w: '5.17.0',
    l: '5.17.0',
    i: '5.17.0',
    a: '5.17.0',
  },
  'theme.getClientSkin': {
    m: '6.1.0',
    w: '6.1.0',
    l: '6.1.0',
  },
  'theme.getEmojiReactionSkin': {
    m: '6.6.0',
    w: '6.6.0',
    l: '6.6.0',
  },
  'theme.registerThemeChangeListener': {
    m: '5.17.0',
    w: '5.17.0',
    l: '5.17.0',
    i: '5.17.0',
    a: '5.17.0',
  },
  'theme.unregisterThemeChangeListener': {
    m: '5.17.0',
    w: '5.17.0',
    l: '5.17.0',
    i: '5.17.0',
    a: '5.17.0',
  },
  'theme.onClientSkinChange': {
    m: '6.1.0',
    w: '6.1.0',
    l: '6.1.0',
    i: '6.2.0',
    a: '6.2.0',
  },
  'theme.offClientSkinChange': {
    m: '6.1.0',
    w: '6.1.0',
    l: '6.1.0',
    i: '6.2.0',
    a: '6.2.0',
  },
  'theme.onWebviewThemeChange': {
    m: '6.1.0',
    w: '6.1.0',
    l: '6.1.0',
    i: '6.2.0',
    a: '6.2.0',
  },
  'theme.offWebviewThemeChange': {
    m: '6.1.0',
    w: '6.1.0',
    l: '6.1.0',
    i: '6.2.0',
    a: '6.2.0',
  },
  'webview.enableHeartbeat': {
    i: '6.6.0',
    a: '6.6.0',
  },
  'webview.disableHeartbeat': {
    i: '6.6.0',
    a: '6.6.0',
  },
  'webview.getHeartbeatStatus': {
    i: '6.6.0',
    a: '6.6.0',
  },
  'webview.closeWebview': {
    i: '5.17.0',
    a: '5.17.0',
  },
  'webview.getWebviewId': {
    m: '6.4.0',
    w: '6.4.0',
    l: '6.4.0',
    i: '6.4.0',
    a: '6.4.0',
  },
  'webview.onVisibilityChange': {
    m: '6.0.5',
    w: '6.0.5',
    l: '6.0.5',
    i: '6.0.5',
    a: '6.0.5',
  },
  'webview.offVisibilityChange': {
    m: '6.0.5',
    w: '6.0.5',
    l: '6.0.5',
  },
  'webview.send': {
    m: '6.2.5',
    w: '6.2.5',
    l: '6.2.5',
    i: '6.2.5',
    a: '6.2.5',
  },
  'webview.onReceiveMessage': {
    m: '6.2.5',
    w: '6.2.5',
    l: '6.2.5',
    i: '6.2.5',
    a: '6.2.5',
  },
  'webview.offReceiveMessage': {
    m: '6.2.5',
    w: '6.2.5',
    l: '6.2.5',
    i: '6.2.5',
    a: '6.2.5',
  },
  'webview.replyNotification': {
    m: '6.2.5',
    w: '6.2.5',
    l: '6.2.5',
    i: '6.2.5',
    a: '6.2.5',
  },
  'webview.getPendingRequests': {
    m: '6.4.10',
    w: '6.4.10',
    l: '6.4.10',
    i: '6.4.10',
    a: '6.4.10',
  },
  'webview.onWebviewWillRecycle': {
    m: '6.4.0',
    w: '6.4.0',
    l: '6.4.0',
  },
  'webview.offWebviewWillRecycle': {
    m: '6.3.0',
    w: '6.3.0',
    l: '6.3.0',
  },
  'webview.onWebviewLostFocus': {
    m: '6.3.0',
    w: '6.3.0',
    l: '6.3.0',
  },
  'webview.offWebviewLostFocus': {
    m: '6.3.0',
    w: '6.3.0',
    l: '6.3.0',
  },
  'webview.saveWebContent': {
    m: '6.3.0',
    w: '6.3.0',
    l: '6.3.0',
  },
  'webview.restoreWebContent': {
    m: '6.3.0',
    w: '6.3.0',
    l: '6.3.0',
  },
  'webview.resize': {
    m: '6.3.0',
    w: '6.3.0',
    l: '6.3.0',
  },
  'webview.getRect': {
    m: '6.5.0',
    w: '6.5.0',
    l: '6.5.0',
  },
  'webview.onPageEnterForeground': {
    i: '6.4.0',
    a: '6.4.0',
  },
  'webview.offPageEnterForeground': {
    m: '6.3.0',
    w: '6.3.0',
    l: '6.3.0',
  },
  'webview.onPageEnterBackground': {
    i: '6.4.0',
    a: '6.4.0',
  },
  'webview.offPageEnterBackground': {
    m: '6.3.0',
    w: '6.3.0',
    l: '6.3.0',
  },
  'webview.getPerformanceMetrics': {
    m: '6.4.0',
    w: '6.4.0',
    l: '6.4.0',
    i: '6.4.0',
    a: '6.4.0',
  },
  'webview.recreate': {
    m: '6.5.0',
    i: '6.4.5',
  },
  'webview.onWebviewZoomFactorChanged': {
    m: '6.6.0',
    w: '6.6.0',
    l: '6.6.0',
  },
  'webview.offWebviewZoomFactorChanged': {
    m: '6.6.0',
    w: '6.6.0',
    l: '6.6.0',
  },
  'webview.setZoomFactor': {
    m: '6.6.0',
    w: '6.6.0',
    l: '6.6.0',
  },
  'webview.getZoomFactor': {
    m: '6.6.0',
    w: '6.6.0',
    l: '6.6.0',
  },
  'webview.readyForPushNotification': {
    i: '6.6.0',
    a: '6.6.0',
  },
  'webview.onPushNotification': {
    i: '6.6.0',
    a: '6.6.0',
  },
  'webview.offPushNotification': {
    i: '6.6.0',
    a: '6.6.0',
  },
  'webview.addShortcutListener': {
    m: '6.6.0',
    w: '6.6.0',
    l: '6.6.0',
  },
  'webview.removeShortcutListener': {
    m: '6.6.0',
    w: '6.6.0',
    l: '6.6.0',
  },
};
